<template>
    <div class=" bg--gray-3">
        <div class="header header--purple header--image">
            <div class="container">
                <div class="row">
                    <div class="main col-12 text-right">
                        <h2
                            v-if="
                                user.contentTypeAlias != 'advisorCEG' &&
                                    user.contentTypeAlias == 'teacher'
                            "
                            class="header__heading"
                        >
                            {{ user.name }}
                        </h2>
                        <h2
                            v-if="
                                user.contentTypeAlias != 'teacher' &&
                                    user.contentTypeAlias == 'advisorCEG'
                            "
                            class="header__heading"
                        ></h2>
                        <h2 v-if="(user.contentTypeAlias = 'advisorCEG')"></h2>
                        <h2 v-else class="header__heading">
                            {{ user.school.name }}
                            {{ user.contentTypeAlias }} 2
                        </h2>

                        <h3
                            v-if="user.contentTypeAlias != 'teacher'"
                            class="font-family--base"
                        >
                            {{ user.contactPersonFirstname }}
                            {{ user.contactPersonInsertion }}
                            {{ user.contactPersonLastname }}
                        </h3>
                        <h3 v-else class="font-family--base">
                            {{ user.fullName }}
                        </h3>
                        <button
                            class="btn-text btn-text--white opacity-60"
                            @click="logout"
                        >
                            Uitloggen <i class="fa fa-sign-out-alt ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="user.memberTypeAlias == 'school' && user.impersonate"
            class="bg--gray-1"
        >
            <div class="container">
                <div class="row">
                    <div class="main col-12">
                        <div class="bg--gray-6 text-right">
                            <button
                                href="#"
                                class="btn--gray-2 color--white"
                                @click="deimpersonate()"
                            >
                                <i class="fas fa-arrow-left mr-2"></i>
                                <span class="color--off-white">
                                    Keer terug als CEG
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="main col-12">
                    <div class="bg--gray-6">
                        <ul class="navbar__links navbar__mijn-menu">
                            <li
                                v-for="item in navigation"
                                :key="item.Url"
                                class="navbar__link"
                                :class="{ active: item.url === pathArray }"
                            >
                                <a :href="item.url">{{ item.title }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            navigation: {}
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    created() {
        this.get();
        const pathArray = window.location.pathname;
        this.pathArray = pathArray;
    },
    methods: {
        get() {
            axios
                .get('/clientdashboard/getnavigation', {})
                .then(response => {
                    if (response != null) {
                        this.navigation = response.data.items;
                    }
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                });
        },
        logout() {
            axios
                .post('/clientdashboard/account/logout', {})
                .then(response => {
                    if (response.data.success) {
                        window.location.replace(response.data.redirectUrl);
                    } else {
                        this.loginError = true;
                    }
                    this.processing = false;
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                });
        },
        deimpersonate() {
            axios
                .post('/api/ClientDashBoardImpersonateAPI/DeImpersonate', {})
                .then(response => {
                    if (response.data.success) {
                        window.location.replace(response.data.redirectUrl);
                    } else {
                        this.loginError = true;
                    }
                    this.processing = false;
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.active a {
    color: #00a09a;
}
</style>
